import { number_to_human_size } from 'number_helpers';

export const numberToBytes = (number) => number_to_human_size(number);
